import React from 'react';
import { object, string } from 'yup';

import { cloneDeep, isNaN, startCase } from 'lodash';

import FormGroup from '~/commons/components/FormGroup.jsx';
import FormCheckGroup from '~/commons/components/FormCheckGroup.jsx';
import { env } from '~/commons/config';

import FormResource from './FormResource.jsx';

const schema = object({
  itemCode: string().required(),
  orgId: string().matches(/^(?:\d+,?)+$/, 'Invalid Organization ID Format'),
});

const defaults = {
  active: true,
  orgId: '',
  itemCode: '',
  description: '',
  uom: '',
  fixedQty: true,
};

const FormService = ({ service }) => (
  <FormResource
    {...{
      defaults,
      schema,
      stored: service
        ? {
          ...service,
          orgId: service.orgId.join(','),
        }
        : undefined,
      api: '/api/core/services',
      onSubmit: (v) => {
        const data = cloneDeep(v);

        data.orgId = [
          ...new Set(
            data.orgId.split(/,\s?/).reduce((acc, cur) => {
              const id = parseInt(cur, 10);
              return isNaN(id) ? acc : [...acc, id];
            }, []),
          ),
        ];
        return data;
      },
    }}>
    <div className="form-group">
      <label>Active</label>
      <FormCheckGroup name="active" type="checkbox" label="" asSwitch />
    </div>
    <div className="row">
      <div className="col">
        <FormGroup name="itemCode" />
      </div>
      <div className="col">
        <FormGroup name="orgId" label="Organization ID (Comma separated)" />
      </div>
    </div>

    <div className="row">
      <div className="col">
        <FormGroup name="description" />
      </div>
    </div>
    <div className="row">
      <div className="col">
        <label>Fixed Quantity</label>
        <FormCheckGroup name="fixedQty" type="checkbox" asSwitch />
      </div>
      <div className="col">
        <FormGroup name="uom" label='Unit of Measurement' as="select">
          {env?.unitOfMeasure.map((v) => (
            <option value={v} key={v}>
              {startCase(v)}
            </option>
          ))}
        </FormGroup>
      </div>
    </div>
  </FormResource>
);

export default FormService;
